import { FunctionComponent, ReactNode } from "react";
import "./Drawer.scss";
import { Drawer } from "antd";
import { useTranslation } from "react-i18next";

type DrawerProps = {
  title: string;
  open?: boolean;
  onClose?: () => void;
  children: ReactNode;
  widthDrawer?: number;
  extraNode?: ReactNode;
  footerNode?: ReactNode;
  bodyStyle?: any;
};

const DrawerCustom: FunctionComponent<DrawerProps> = ({
  title,
  open,
  onClose,
  children,
  widthDrawer,
  extraNode,
  footerNode,
  bodyStyle,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Drawer
        title={typeof title === "string" ? t(title, title) : title}
        open={open}
        onClose={onClose}
        width={widthDrawer}
        placement="right"
        extra={extraNode}
        styles={{
          body: bodyStyle,
        }}
        maskClosable={false}
        footer={footerNode}
      >
        {children}
      </Drawer>
    </>
  );
};

export default DrawerCustom;
